module.exports = __webpack_public_path__ + "media/images/icons/store_categories/icon-store-no-icon-ce695411e73bb89f56458948b707eb01.svg";